import React from 'react';
import Vision from '../Sections/vision';
import About from '../Sections/about';

export default function AboutPage() {
  return (
    <>
      <Vision />
      <About />
    </>
  );
}
